import React from "react"
import { Constant } from "../../helper/constant";
import { httpClient } from "../../helper/utils";

/**
 * @param {string} keyword
 * @param {Omit<RequestInit, "method" | "headers">} [requestInit]
 */
async function getDoctorAutocomplete(keyword, requestInit) {
  const token = localStorage.getItem("token")
  const response = await httpClient(
    `${Constant.BASE_API_URL}/dokter/autocomplete?keyword=${keyword}`,
    {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      ...requestInit,
    }
  );
  return response.json();
}

/**
 * @param {string} keyword
 * @param {boolean} shouldFetch - data fetch control
 */
export function useDoctorAutocomplete(keyword, shouldFetch = true) {
  const [data, setData] = React.useState([])
  const [isLoading, setIsLoading] = React.useState(false)
  const [isError, setIsError] = React.useState(false)

  React.useEffect(() => {
    if (!shouldFetch) return

    if (!keyword || keyword.length < 2) {
      setData([])
      setIsLoading(false)
      setIsError(false)
      return
    }

    const controller = new AbortController()

    async function fetchData() {
      setIsLoading(true)
      try {
        const response = await getDoctorAutocomplete(keyword, {
          signal: controller.signal
        })
        setData(response.data.doctors)
        setIsLoading(false)
      } catch (error) {
        if (error.name !== "AbortError") {
          setData([])
          setIsError(true)
        }
        setIsLoading(false)
      }
    }

    fetchData()

    return () => {
      controller.abort()
    }
  }, [keyword, shouldFetch])

  const reset = () => {
    setData([])
  }

  return {
    data,
    isLoading,
    isError,
    reset,
  }
}
